'use strict';

let isDesktop = Foundation.MediaQuery.atLeast('large');

let setFullHeight = function () {
    let windowHeight = $(window).innerHeight();
    let bodyOffset = 0;
    if ($('.cc-hpModules').length > 0) {
        bodyOffset = $('.cc-hpModules').position().top;
    }
    document.documentElement.style.setProperty('--windowHeight', windowHeight - bodyOffset + 'px');
};

let sliderReinit = function () {
    if ($('.cc-emSlider').length > 0) {
        if ($(this)) {
            $('.cc-emSlider').each(function () {
                $(this).not('.slick-initialized').slick('reinit');
            });
        }
    }
};

let initVideo = function () {
    if ($('video.cc-em__video').length > 0) {
        $('video.cc-em__video').each(function () {
            let videoSrc = '';
            if (isDesktop) {
                videoSrc = $(this).data('desktop-video');
            } else {
                videoSrc = $(this).data('mobile-video');
            }
            let oldSrc = $(this).find('source').attr('src');
            if (oldSrc !== videoSrc) {
                $(this).html('<source src="' + videoSrc + '" type="video/mp4">');
                $(this)[0].load();
            }
        });
    }
};
function fillDomElement (einsteinResponse, $parentElement) {
    var recommender = $parentElement.data('recommender');
    var recommendedProducts = einsteinResponse[recommender].recs;
    var count = recommendedProducts.length;
    var removed = 0;
    var added = 0;
    var rec = [];
    for (var i = 0; i < recommendedProducts.length; i++) {
        rec.push(recommendedProducts[i].id);
    }
    if (recommendedProducts && recommendedProducts.length > 0) {
        var url = new URL($parentElement.data('product-load-url'));
        var replacementCategory = $parentElement.data('replacementCategoryId');
        replacementCategory && url.searchParams.append('replacementCategory', replacementCategory);
        url.searchParams.append('pids', rec.join(','));
        url.searchParams.append('recommender', recommender);
        $.ajax({
            url: url.href,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                $parentElement.find('.js-einstein-container').append(html);
                $('.einstein-product-tile').each(function (_, e) {
                    if ($(e).find('[data-pid="null"]').length > 0) {
                        $(e).remove();
                    }
                });
                $parentElement.find('.js-einstein-container').find('script').each((idx, val) => {
                    $(val).detach().appendTo('body');
                });
                $('.js-einstein-carousel').each((idx, carousel) => {
                    var $recommendationTiles = carousel;
                    let searchResults = $($recommendationTiles).find('.js-einstein-container').children();
                    if (searchResults.length > 0) {
                        $($recommendationTiles).parents('.js-carouselComponent').removeClass('hidden');
                    }
                });
                $('body').trigger('listing:einsteinloaded', {container: $parentElement.find('.js-einstein-container'), type: 'listing'});
            },
            error: function () {
                $parentElement.spinner().stop();
            }
        });
    }
}

function getEinsteinUtils () {
    var einsteinUtils = window.CQuotient;
    if (einsteinUtils && (typeof einsteinUtils.getCQUserId === 'function') && (typeof einsteinUtils.getCQCookieId === 'function')) {
        return einsteinUtils;
    }
    return null;
}
function processRecommendationsTile ($parentElement, recs, anchorsArray) {
    var recommender = $parentElement.data('recommender');
    var einsteinUtils = getEinsteinUtils();
    var params = {
        userId: einsteinUtils.getCQUserId(),
        cookieId: einsteinUtils.getCQCookieId(),
        ccver: '1.01'
    };

    if (anchorsArray) {
        params.anchors = anchorsArray;
    }

    /**
    * Processes a recommendation responses
    * @param {Object} einsteinResponse cquotient object
    */
    function recommendationsReceived (einsteinResponse) {
        fillDomElement(einsteinResponse, $parentElement);
        $parentElement.spinner().stop();
    }
    if (einsteinUtils.getRecs) {
        einsteinUtils.getRecs(einsteinUtils.clientId, recommender, params, recommendationsReceived);
    } else {
        einsteinUtils.widgets = einsteinUtils.widgets || []; // eslint-disable-line no-param-reassign
        einsteinUtils.widgets.push({
            recommenderName: recommender,
            parameters: params,
            callback: recommendationsReceived
        });
    }
}
function loadRecommendations () {
    $('.js-einstein-carousel').each((idx, carousel) => {
        var $recommendationTiles = carousel;
        processRecommendationsTile($($recommendationTiles));
        let searchResults = $($recommendationTiles).find('.js-einstein-container').children();
        if (searchResults.length > 0) {
            $($recommendationTiles).parents('.js-carouselComponent').removeClass('hidden');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    loadRecommendations();
});

$(document).ready(function () {
    isDesktop = Foundation.MediaQuery.atLeast('large');
    setFullHeight();
    initVideo();

    // Slider Init
    if ($('.cc-emSlider').length > 0) {
        $('.cc-emSlider').each(function () {
            $(this).not('.slick-initialized').slick();
        });
    }

    // Hero
    if ($('.cc-emHero').length > 0) {
        $('.cc-emHero').each(function () {
            if (($(this).find('.cc-emHero__item').length < 2) && ($(this).find('.cc-emHero__item video').length < 1)) {
                $(this).find('.cc-emHero__playBtn').hide();
            }
        });
    }
    $(document).on('click', '.cc-emHero .js-heroPlayBtn', function () {
        let slider = $(this).closest('.cc-emHero__wrp').find('.cc-emSlider');
        let videoExists = false;
        let $video = false;

        if ($(this).closest('.cc-emHero__wrp').find('video').length > 0) {
            videoExists = true;
            $video = $(this).closest('.cc-emHero__wrp').find('video');
        }

        if ($(this).hasClass('cc-paused')) {
            $(slider).slick('slickPlay');
            $(this).removeClass('cc-paused');
            if (videoExists) {
                for (let v of $video) {
                    v.play();
                }
            }
        } else {
            $(slider).slick('slickPause');
            $(this).addClass('cc-paused');
            if (videoExists) {
                for (let v of $video) {
                    v.pause();
                }
            }
        }
    });

    // Custom Carousel
    function carouselScroll (el, dir) {
        const carousel = $(el).closest('.cc-em').find('.cc-em__carouselCustom');
        const carouselItemsWidth = parseInt($(carousel).children().outerWidth());
        let carouselScrolled = $(carousel).scrollLeft();

        if (dir === 'right') {
            $(carousel).scrollLeft(carouselScrolled + carouselItemsWidth);
        } else {
            $(carousel).scrollLeft(carouselScrolled - carouselItemsWidth);
        }
    }

    $(document).on('click', '.js-carouselCustom__arrowLeft', function () {
        carouselScroll(this, 'left');
    });

    $(document).on('click', '.js-carouselCustom__arrowRight', function () {
        carouselScroll(this, 'right');
    });

    if ($('.cc-em__carouselCustom').length > 0) {
        $('.cc-em__carouselCustom').each(function () {
            const carousel = $(this);
            let carouselWidth = parseInt($(carousel).outerWidth());
            let carouselItemsNumber = $(carousel).children().length;
            let carouselItemsWidth = parseInt($(carousel).children().outerWidth());
            let carouselItemsWidthSum = carouselItemsWidth * carouselItemsNumber;

            if ((carouselItemsWidthSum + 16) <= carouselWidth) {
                $(this).closest('.cc-em').find('.cc-em__carouselCustom__arrows').hide();
            }

            $(this).scroll(function () {
                carouselWidth = parseInt($(carousel).outerWidth());
                carouselItemsNumber = $(carousel).children().length;
                carouselItemsWidth = parseInt($(carousel).children().outerWidth());
                carouselItemsWidthSum = carouselItemsWidth * carouselItemsNumber;
                let carouselScrolled = $(carousel).scrollLeft();

                if (carouselScrolled < 1) {
                    $(carousel).closest('.cc-em').find('.js-carouselCustom__arrowLeft').addClass('cc-disabled');
                } else if (carouselScrolled >= (carouselItemsWidthSum - carouselWidth + 16)) {
                    $(carousel).closest('.cc-em').find('.js-carouselCustom__arrowRight').addClass('cc-disabled');
                } else {
                    $(carousel).closest('.cc-em').find('.js-carouselCustom__arrowLeft').removeClass('cc-disabled');
                    $(carousel).closest('.cc-em').find('.js-carouselCustom__arrowRight').removeClass('cc-disabled');
                }
            });
        });
    }

    // Shoppable Video
    let shoppableVideoInterval;
    let shoppableVideoIsPaused = false;
    let shoppableVideoRestart = false;

    if ($('.cc-emShoppableVideo').length > 0) {
        $('.cc-emShoppableVideo').each(function () {
            let $this = $(this);
            let cards = $(this).find('.cc-emShoppable__productCard');
            let cardNumber = cards.length;
            let i = 0;
            let x = 0;

            shoppableVideoInterval = setInterval(
                function () {
                    if (shoppableVideoRestart) {
                        for (x = 0; x < cardNumber; x++) {
                            shoppableVideoRestart = false;
                            $(cards[x]).removeAttr('style').removeClass('cc-initialized');
                        }
                        x = 0;
                    }
                    if (!shoppableVideoIsPaused && $this.find('.cc-emShoppable__productCard--opened.cc-active').length < 1 && $('.js-prodTile-quickAdd-modal_open').length < 1) {
                        $(cards[i]).addClass('cc-visible');
                        $(cards[i]).addClass('cc-initialized');
                        $(cards[i]).addClass('cc-active');
                        if ((i !== 0) && (i <= cardNumber - 1)) {
                            $(cards[i - 1]).removeClass('cc-active');
                            for (x = 0; x < i; x++) {
                                let scaleVal = 1 - ((i - x) * 0.1);
                                $(cards[x]).css({
                                    'transform': 'scale(' + scaleVal + ')',
                                    'margin-bottom': (i - x) * 15 + 'px'
                                });
                            }
                        }

                        if (i >= cardNumber) {
                            for (x = 0; x < i; x++) {
                                $(cards[x]).removeClass('cc-visible cc-active');
                            }
                            i = 0;
                            shoppableVideoRestart = true;
                        } else {
                            i++;
                        }

                        if (cardNumber === 0) {
                            clearInterval(shoppableVideoInterval);
                        }
                    }
                },
                3000
            );
        });

        $(document).on('click', '.cc-emShoppableVideo .js-emShoppableVideoPlayBtn', function () {
            let videoExists = false;
            let $video = false;

            if ($(this).closest('.cc-emShoppableVideo__media').find('video').length > 0) {
                videoExists = true;
                $video = $(this).closest('.cc-emShoppableVideo__media').find('video');
            }

            if ($(this).hasClass('cc-paused')) {
                $(this).removeClass('cc-paused');
                if (shoppableVideoIsPaused) {
                    shoppableVideoIsPaused = false;
                }
                if (videoExists) {
                    for (let v of $video) {
                        v.play();
                    }
                }
            } else {
                $(this).addClass('cc-paused');
                if (!shoppableVideoIsPaused) {
                    shoppableVideoIsPaused = true;
                }
                if (videoExists) {
                    for (let v of $video) {
                        v.pause();
                    }
                }
            }
        });
    }

    // Shoppable Image
    if ($('.cc-emShoppableImage').length > 0) {
        $(document).on('click', '.cc-emShoppableImage .js-emShoppableImage__hotspotBtn', function () {
            $(this).closest('.cc-emShoppableImage__hotspotWrp').siblings().removeClass('cc-emShoppableImage__hotspotWrp--open');
            $(this).closest('.cc-emShoppableImage__hotspotWrp').toggleClass('cc-emShoppableImage__hotspotWrp--open');
        });
    }

    // Window Resize
    $(window).resize(function () {
        isDesktop = Foundation.MediaQuery.atLeast('large');
        setFullHeight();
        initVideo();
        sliderReinit();
    });
});
